import { IColumn } from "../../../shared/components/normal-table/normal-table";
import "./event-captures.scss";
import ListPage from "../../components/list-page/list-page";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  }
];

const EventCapturesList = () => {
  return (
    <div className="eventCaptureList">
      <ListPage
        title={"Event capture screens"}
        defaultSortCol={"name"}
        columns={columns}
        dataUrl={{
          url: "captures",
          queryString: "datamodel_type=event",
          backend: "manager"
        }}
        deleteUrl={{
          url: "captures",
          queryString: "datamodel_type=event",
          backend: "manager"
        }}
      />
    </div>
  );
};

export default EventCapturesList;